import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';
import { UserInteractor, UserInteractorType } from '../UserInteractor';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

export class OpenRolePrivsCommand extends CategoryCommand<void> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.ACCESS_RIGHTS_ASSIGNMENT,
    };
  }

  public getIcon(): IconName {
    return 'privs';
  }

  public isAvailable(context: ClientContext): boolean {
    return context.has('Id');
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.NONE;
  }

  public async getUserInteractor(): Promise<UserInteractor> {
    return {
      type: UserInteractorType.ROLE_PRIVS,
    };
  }

  public getName(): CommandName {
    return 'openRolePrivs';
  }
}
